import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-packers-movers-config',
  templateUrl: './add-packers-movers-config.component.html',
  styleUrls: ['./add-packers-movers-config.component.sass']
})
export class AddPackersMoversConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
